$bog_smalljs_top $mol_view
	Theme null
	github_uri \https://github.com/hyoo-ru/mam_mol
	logo_uri \bog/smalljs/assets/logo.svg
	search_click? null
	nav_pick? null
	sub /
		<= Logo $mol_link
			arg *
				section null
				page null
			sub /
				<= Logo_image $mol_image
					uri <= logo_uri
					title @ \smalljs
				<= Logo_text_box $mol_view
					sub /
						<= Logo_text \$mol
		<= Search $mol_button_minor
			click? <=> search_click?
			sub /
				<= Search_icon $mol_icon_magnify
				<= Search_label $mol_view
					sub /
						<= Search_label_text @ \Search
				<= Search_hint $mol_view
					sub /
						<= Search_hint_text @ \⌘ K
		<= Nav $mol_view
			sub /
				<= Docs_pick $mol_pick
					hint @ \Docs
					align \bottom_left
					trigger_content /
						<= Docs_label @ \Docs
						<= Docs_chevron $mol_icon_chevron_down
					bubble_content /
						<= Docs_menu $mol_view
							sub /
								<= Docs_quickstart $mol_link
									title @ \Quick Start
									arg *
										section \docs
										page \getting-started
									event_click? <=> nav_pick?
								<= Docs_guide $mol_link
									title @ \Guide
									arg *
										section \docs
										page \views
									event_click? <=> nav_pick?
								<= Docs_tutorial $bog_smalljs_top_item
									title @ \Tutorial
									arg *
										section \course
										page null
									event_click? <=> nav_pick?
								<= Docs_examples $mol_link
									title @ \Examples
									arg *
										section \docs
										page \showcase
									event_click? <=> nav_pick?
								<= Docs_api $mol_link
									title @ \API
									arg *
										section \docs
										page \api-mol-string
									event_click? <=> nav_pick?
				<= Nav_playground $bog_smalljs_top_item
					title @ \Playground
					arg *
						section \playground
						page null
				<= Nav_versus $bog_smalljs_top_item
					title @ \Compare
					arg *
						section \versus
						page null
				<= Ecosystem_pick $mol_pick
					hint @ \Ecosystem
					align \bottom_left
					trigger_content /
						<= Ecosystem_label @ \Ecosystem
						<= Ecosystem_chevron $mol_icon_chevron_down
					bubble_content /
						<= Ecosystem_menu $mol_view
							sub /
								<= Eco_components $mol_link
									title @ \UI Components
									uri \https://mol.hyoo.ru/#!section=demos
									event_click? <=> nav_pick?
								<= Eco_libs_title $mol_view
									sub /
										<= Eco_libs_title_text @ \Official Libraries
								<= Eco_wire $mol_link
									title @ \$mol_wire
									uri \https://github.com/hyoo-ru/mam_mol/tree/master/wire
									event_click? <=> nav_pick?
								<= Eco_fetch $mol_link
									title @ \$mol_fetch
									uri \https://github.com/hyoo-ru/mam_mol/tree/master/fetch
									event_click? <=> nav_pick?
								<= Eco_compare $mol_link
									title @ \$mol_compare_deep
									uri \https://github.com/hyoo-ru/mam_mol/tree/master/compare/deep
									event_click? <=> nav_pick?
								<= Eco_router $mol_link
									title @ \$mol_state_arg
									uri \https://github.com/hyoo-ru/mam_mol/tree/master/state/arg
									event_click? <=> nav_pick?
								<= Eco_crowd $mol_link
									title @ \$hyoo_crowd
									uri \https://github.com/hyoo-ru/crowd.hyoo.ru
									event_click? <=> nav_pick?
								<= Eco_baza $mol_link
									title @ \Giper Baza
									uri \https://github.com/giper-dev/baza
									event_click? <=> nav_pick?
				<= About_pick $mol_pick
					hint @ \About
					align \bottom_left
					trigger_content /
						<= About_label @ \About
						<= About_chevron $mol_icon_chevron_down
					bubble_content /
						<= About_menu $mol_view
							sub /
								<= About_faq $mol_link
									title @ \FAQ
									arg *
										section \docs
										page \faq
									event_click? <=> nav_pick?
								<= About_team $mol_link
									title @ \Team
									arg *
										section \docs
										page \team
									event_click? <=> nav_pick?
								<= About_releases $mol_link
									title @ \Releases
									arg *
										section \docs
										page \releases
									event_click? <=> nav_pick?
								<= About_telegram $mol_link
									title @ \Telegram
									uri \https://t.me/giper_dev
									event_click? <=> nav_pick?
		<= Burger $mol_pick
			hint @ \Menu
			align \bottom_right
			trigger_content /
				<= Burger_icon $mol_icon_hamburger
			bubble_content /
				<= Mobile_menu $mol_view
					sub /
						<= Mobile_playground $bog_smalljs_top_item
							title @ \Playground
							arg *
								section \playground
								page null
							event_click? <=> nav_pick?
						<= Mobile_versus $bog_smalljs_top_item
							title @ \Compare
							arg *
								section \versus
								page null
							event_click? <=> nav_pick?
						<= Docs_group $mol_expander
							title @ \Docs
							content /
								<= M_docs_quickstart $mol_link
									title @ \Quick Start
									arg *
										section \docs
										page \getting-started
									event_click? <=> nav_pick?
								<= M_docs_guide $mol_link
									title @ \Guide
									arg *
										section \docs
										page \views
									event_click? <=> nav_pick?
								<= M_docs_tutorial $bog_smalljs_top_item
									title @ \Tutorial
									arg *
										section \course
										page null
									event_click? <=> nav_pick?
								<= M_docs_examples $mol_link
									title @ \Examples
									arg *
										section \docs
										page \showcase
									event_click? <=> nav_pick?
								<= M_docs_api $mol_link
									title @ \API
									arg *
										section \docs
										page \api-mol-string
									event_click? <=> nav_pick?
						<= Ecosystem_group $mol_expander
							title @ \Ecosystem
							content /
								<= M_eco_components $mol_link
									title @ \UI Components
									uri \https://mol.hyoo.ru/#!section=demos
									event_click? <=> nav_pick?
								<= M_eco_libs_title $mol_view
									sub /
										<= M_eco_libs_title_text @ \Official Libraries
								<= M_eco_wire $mol_link
									title @ \$mol_wire
									uri \https://github.com/hyoo-ru/mam_mol/tree/master/wire
									event_click? <=> nav_pick?
								<= M_eco_fetch $mol_link
									title @ \$mol_fetch
									uri \https://github.com/hyoo-ru/mam_mol/tree/master/fetch
									event_click? <=> nav_pick?
								<= M_eco_compare $mol_link
									title @ \$mol_compare_deep
									uri \https://github.com/hyoo-ru/mam_mol/tree/master/compare/deep
									event_click? <=> nav_pick?
								<= M_eco_router $mol_link
									title @ \$mol_state_arg
									uri \https://github.com/hyoo-ru/mam_mol/tree/master/state/arg
									event_click? <=> nav_pick?
								<= M_eco_crowd $mol_link
									title @ \$hyoo_crowd
									uri \https://github.com/hyoo-ru/crowd.hyoo.ru
									event_click? <=> nav_pick?
								<= M_eco_baza $mol_link
									title @ \Giper Baza
									uri \https://github.com/giper-dev/baza
									event_click? <=> nav_pick?
						<= About_group $mol_expander
							title @ \About
							content /
								<= M_about_faq $mol_link
									title @ \FAQ
									arg *
										section \docs
										page \faq
									event_click? <=> nav_pick?
								<= M_about_team $mol_link
									title @ \Team
									arg *
										section \docs
										page \team
									event_click? <=> nav_pick?
								<= M_about_releases $mol_link
									title @ \Releases
									arg *
										section \docs
										page \releases
									event_click? <=> nav_pick?
								<= M_about_telegram $mol_link
									title @ \Telegram
									uri \https://t.me/giper_dev
									event_click? <=> nav_pick?
		<= Lang_pick $mol_pick
			hint @ \Language
			align \bottom_right
			trigger_content /
				<= Lang_icon $mol_icon_translate
				<= lang_label \EN
				<= Lang_chevron $mol_icon_chevron_down
			bubble_content /
				<= Lang_menu $mol_view
					sub <= lang_options /
		<= Theme_toggle $bog_theme_switch
			theme_auto <= Theme
		<= Github $mol_link_source
			uri <= github_uri
	Lang_option* $mol_button_minor
		sub /
			<= lang_option_label* \
			<= Lang_option_check* $mol_icon_check

$bog_smalljs_top_item $mol_link
	uri_off <= uri
